import { getTranslations } from 'next-intl/server';
import { HeroBgImageWrap, HeroWrapper } from './styled';
import heroBg from '@/assets/webp/hero-bg.webp';
import { Typography } from '@mui/material';
import { COLORS } from '@/constants';
import { Container } from '@/features/components/styled';
import { SearchFilter } from './SearchFilter';

export const Hero = async () => {
  const t = await getTranslations();
  return (
    <HeroWrapper>
      <HeroBgImageWrap>
        <img src={heroBg.src} alt="Hero background image" fetchPriority="high" />
      </HeroBgImageWrap>
      <Container>
        <Typography
          fontSize={{ xs: 29, sm: 34, md: 42 }}
          fontWeight={700}
          textAlign="center"
          color={COLORS.white}
          marginBottom={{ xs: 2, sm: 3, md: 5 }}
          style={{ textShadow: '1px 2px 8px rgba(0, 0, 0, 0.45)' }}
        >
          {t('mainHero.title')}
        </Typography>
        <SearchFilter />
      </Container>
    </HeroWrapper>
  );
};
